import React, { useState, useEffect } from "react";
import Modal from "react-modal";

const ModalChangePricesAndQuotas = (props) => {
    const [fieldData, setFieldData] = useState({});

    const handleFieldChange = (fieldName, operator, value) => {
        setFieldData((pr) => ({
            ...pr,
            [fieldName]: { operator, value },
        }));
    };

    //установка значений по умолчанию
    useEffect(() => {
        cleanFields(props?.selectedFields, "Квота", props?.thisPrices)?.forEach(
            (f) => {
                handleFieldChange(f.name, "=", 0);
            },
        );
    }, []);

    return (
        <Modal
            isOpen={props.isOpenModal}
            close={!props.isOpenModal}
            onRequestClose={props.handleOpenModal}
            className="custom-modal"
            overlayClassName="custom-modal-overlay"
            ariaHideApp={false}
        >
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    props.setClose(false);
                    props.handleSubmit(e, fieldData, props?.thisQuotas);
                }}
            >
                <div className="modal-title">{props.title}</div>
                <div className="modal-content">
                    {cleanFields(
                        props?.selectedFields,
                        "Квота",
                        props?.thisPrices,
                    )?.map((f) => (
                        <div className="modal-element" key={"fields_" + f.id}>
                            <span>{f.name}</span>
                            <select
                                required={true}
                                value={fieldData[f.name]?.operator || "="}
                                onChange={(e) =>
                                    handleFieldChange(
                                        f.name,
                                        e.target.value,
                                        fieldData[f.name]?.value || "=",
                                    )
                                }
                            >
                                <option value="=">=</option>
                                <option value="+">+</option>
                                <option value="%">%</option>
                            </select>
                            <input
                                required={true}
                                type="number"
                                value={fieldData[f.name]?.value ?? 0}
                                onChange={(e) =>
                                    handleFieldChange(
                                        f.name,
                                        fieldData[f.name]?.operator || "=",
                                        e.target.value,
                                    )
                                }
                                placeholder="Введите число"
                            />
                        </div>
                    ))}
                </div>
                <div className="modal-button-container">
                    <button
                        className="modal-button black-button"
                        type={"submit"}
                    >
                        Изменить
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default ModalChangePricesAndQuotas;

export const cleanFields = (fields, name, thisPrice = false) =>
    fields?.filter((f) => (thisPrice ? f.name !== name : f.name === name));
